export default "__VITE_ASSET__527c68e8__"